<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><a class="page" id="piv"></a>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2019 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.</p>
<p class="crt">Published 2019</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">28 27 26 25 24 23 22 21 20 19    1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-61770-1 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-61784-8 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226617848.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226617848.001.0001</a></p>
<p class="crtf">This book has been supported by the Margarita M. Hanson Endowment of the American Musicological Society, funded in part by the National Endowment for the Humanities and the Andrew W. Mellon Foundation.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Yearsley, David Gaynor, author.</p>
<p class="cip">Title: Sex, death, and minuets : Anna Magdalena Bach and her musical notebooks / David Yearsley.</p>
<p class="cip">Other titles: New material histories of music.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2019. | Series: New material histories of music | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2018060694 | ISBN 9780226617701 (cloth : alk. paper) | ISBN 9780226617848 (e-book)</p>
<p class="cip">Subjects: LCSH: Bach, Anna Magdalena, 1701–1760—Notebooks, sketchbooks, etc. | Bach, Anna Magdalena, 1701–1760—Criticism and interpretation. | Music—Germany—18th century—History and criticism.</p>
<p class="cip">Classification: LCC ML410.B1 Y43 2019 | DDC 780.92—dc23</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2018060694" target="_blank">https://lccn.loc.gov/2018060694</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48–1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-yearsley-0005.vue?61996e2a